"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsoDateForTimeZone = void 0;
const timeZones_1 = require("../../constants/timeZones");
const getIsoDateForTimeZone = (tz = undefined, date = undefined) => {
    const locale = 'en-US';
    const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: tz ? tz : timeZones_1.TIME_ZONE.EASTERN,
    };
    const formatParts = Intl.DateTimeFormat(locale, options).formatToParts(date ? date : new Date());
    let mm, dd, yyyy;
    formatParts.forEach((part) => {
        if (part.type === 'month') {
            const { value: month } = part;
            mm = month.length < 2 ? `0${month}` : month;
        }
        else if (part.type === 'day') {
            const { value: day } = part;
            dd = day.length < 2 ? `0${day}` : day;
        }
        else if (part.type === 'year') {
            yyyy = part.value;
        }
    });
    return `${yyyy}-${mm}-${dd}`;
};
exports.getIsoDateForTimeZone = getIsoDateForTimeZone;
//# sourceMappingURL=index.js.map